export const ALPA_NUMERICS = /^[a-zA-Z0-9]*$/;
export const NUMERICS = /^[0-9]*$/;
export const EMAIL_REGEX = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
